import actionCreatorFactory from 'typescript-fsa';
import { User } from '../../../models/User';
// actionのprefixを設定
const actionCreator = actionCreatorFactory('user');

const updateUserInfoAction = actionCreator<User>('UPDATE_USER_INFO');

export { updateUserInfoAction };



// WEBPACK FOOTER //
// ./src/redux/modules/user/actions.ts